import React from 'react';
import './input.sass';

export const InputType = {
  TEXT: 'text',
  PASSWORD: 'password'
};

export const InputStyle = {
  PRIMARY: 'primary',
  UNIQUE_LANDING_PAGE: 'unique-landing-page'
};

export const InputSize = {
  DEFAULT: 'default',
  SMALL: 'small',
  BIG: 'big'
};

export const Input = ({min, max, placeholderAfterValue, defaultValue, placeholder, onChange, onBlur, value, name, id, label, textError, permanentPlaceholder, maxLength, type = InputType.TEXT, inputStyle = InputStyle.PRIMARY, inputSize = InputSize.DEFAULT, disabled = false}) => {
  return (
    <div className='vv-input-container'>
      { label ? <p className={`vv-input-container__label vv-input-container__label--${inputStyle}`}>{label}</p>: null}
      <input className={`vv-input vv-input--${inputStyle} vv-input--${inputSize}  ${textError ? `vv-input__error--${inputStyle}` : ''}`}
             id={id}
             name={name}
             type={type}
             value={value}
             placeholder={placeholder}
             defaultValue={defaultValue}
             onChange={onChange}
             min={min}
             max={max}
             maxLength={maxLength}
             onBlur={onBlur}
             disabled={disabled}/>
      { placeholderAfterValue ? <span className='vv-input-container__placeholder-after-value'>{placeholderAfterValue}</span> : null}
      { permanentPlaceholder ? <span className='vv-input-container__permanent-placeholder'>{permanentPlaceholder}</span> : null}
      { textError ?
          <div className='vv-input__error-message-container'>
            <span className='vv-input-container__error'>{textError}</span>
          </div>
          :
          null }
    </div>
  );
};
